import { render, staticRenderFns } from "./SocialPostView.vue?vue&type=template&id=aa1e9b44&"
import script from "./SocialPostView.vue?vue&type=script&lang=js&"
export * from "./SocialPostView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports